import React from 'react';
import { paths } from 'routes/paths';
import Applications from 'screens/Applications&WorkOrders/Applications';
import RouteAdmin, { Flow } from 'screens/Applications&WorkOrders/RouteAdmin';
import { OperationType } from 'components/RecordsListView/constants';
import ExportApplicationPdf from 'screens/Applications&WorkOrders/Applications/ExportApplicationPdf';
import { ROLES } from 'utilities/access';

const navRoutes = [
  {
    id: 'applications',
    key: 'applications',
    path: paths.applications,
    exact: true,
    secure: true,
    disabled: false,
    component: Applications
  }
];
const allRoutes = [
  ...navRoutes,
  {
    id: 'applicationsCreate',
    key: 'applicationsCreate',
    path: `${paths.applications}/create`,
    exact: true,
    secure: true,
    component: () => (
      <RouteAdmin
        flow={Flow.CREATE}
        operationType={OperationType.APPLICATION}
      />
    )
  },
  {
    id: 'applicationsEdit',
    key: 'applicationsEdit',
    path: `${paths.applications}/:id/edit`,
    exact: true,
    secure: true,
    component: () => (
      <RouteAdmin flow={Flow.EDIT} operationType={OperationType.APPLICATION} />
    ),
    minPermissions: {
      minAllowedRole: ROLES.FULL_CONTROL
    }
  },
  {
    id: 'applicationsExport',
    key: 'applicationsExport',
    path: `${paths.applications}/export/:applicationId`,
    exact: true,
    secure: true,
    component: ExportApplicationPdf,
    minPermissions: {
      minAllowedRole: ROLES.VIEW_ONLY
    }
  }
];

export default { navRoutes, allRoutes };
